import React, { useMemo } from 'react';
import { Button, Col, Row } from 'antd';
import Map from './Map';
import AddressForm from './index';
import { MapProvider } from "./map.context";
import { Marker } from "react-google-maps";
import PinGvg from "../../../../assets/icons/pin.svg";
import { TooltipTrimmedNew } from "../../../../components/Tooltip/TooltipTrimmed";

export default function FormItem({ value, onChange }) {
  const center = useMemo(() => {
    if (!value || !value.coordinate) {
      return null;
    }
    return {
      lat: value.coordinate.latitude,
      lng: value.coordinate.longitude
    }
  }, [value]);

  return (
    <Col>
      <Row type="flex" align="stretch">
          {value && value.full ? (
            <TooltipTrimmedNew str={value.full} />
          ) : null}
        <AddressForm value={value} onChange={onChange}/>
      </Row>
      <MapProvider>
        <Map center={center}>
          {center ? (
            <Marker
              position={center}
              icon={PinGvg}
            />
          ) : null}
        </Map>
      </MapProvider>
    </Col>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Places/components/Address/FormItem.js